var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-container',{class:_vm.$vuetify.breakpoint.mobile ? 'mt-4' : 'mt-8'},[_c('h1',[_vm._v(_vm._s(_vm.$t("logInTitle")))]),_c('p',[_vm._v(_vm._s(_vm.$t("logInDescription")))]),_c('div',{attrs:{"id":"google_btn"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }